import { render, staticRenderFns } from "./ResultToric.vue?vue&type=template&id=710590f5&scoped=true"
import script from "./ResultToric.vue?vue&type=script&lang=js"
export * from "./ResultToric.vue?vue&type=script&lang=js"
import style0 from "./ResultToric.vue?vue&type=style&index=0&id=710590f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710590f5",
  null
  
)

export default component.exports